import React, { useEffect, useState } from "react";
import dayjs from "dayjs";
import {
  child,
  endAt,
  endBefore,
  limitToLast,
  onValue,
  orderByChild,
  query,
  ref,
  startAt,
} from "firebase/database";
import styled from "styled-components";
import { database } from "../../../../fBase";
import Blank from "../../../../DefaultStyles/Blank";
import LineBox from "../../../../DefaultStyles/LineBox";
import Table from "../../../../Table/Table";
import { ChatSection, ChatSectionTitle } from "./OldChatSeachResult";
import RecentChatHeader from "./OldRecentChatHeader";
import { toast } from "react-toastify";
import RecentChatMessage from "./OldRecentChatMessage";
import { isBeta } from "../../../../../AdminConfig";

interface RecentChatProps {
  dropDownValue: {
    label?: string;
  };
  searchValue?: string;
  chatId?: string;
}

interface SMessageCheckIcon {
  isRead: boolean;
}

export interface IMessageData extends SMessageCheckIcon {
  msg: string;
  time: number;
  sendBy: number;
  receivedBy: number;
  key: string | null;
}

export default function RecentChat({
  dropDownValue,
  searchValue,
  chatId,
}: RecentChatProps) {
  const [messageData, setMessageData] = useState<IMessageData[]>([]);
  const [dateData, setDateData] = useState({
    btn: false,
    startDate: "날짜 선택",
    endDate: "날짜 선택",
  });

  const [cnt, setCnt] = useState(0);
  const [more, setMore] = useState(false);
  const [lastTime, setLastTime] = useState(0);
  const [dataSliceValue, setDataSliceValue] = useState(10);
  const [moreMessageData, setMoreMessageData] = useState<IMessageData[]>([]);

  const tableHead = ["보낸 사람", "내용", "발송 일시", "MSG ID"];

  const getMessage = (clickCnt: number, isFirst: boolean) => {
    const dbRef = ref(database, isBeta ? "Beta/Messages" : "Live/Messages");
    const chatRoomsRef = child(dbRef, chatId!);

    let sDate = dateData?.btn ? dayjs(dateData?.startDate).valueOf() : null;
    let eDate = dateData?.btn
      ? dayjs(dateData?.endDate).add(1, "days").valueOf()
      : null;

    console.log(sDate, eDate);
    console.log("dateData?.btn", dateData?.btn);

    const orderedChatRoomsRef = dateData?.btn
      ? // 날짜 별 조회 최신순으로 정렬
        query(
          chatRoomsRef,
          orderByChild("message/time"),
          startAt(sDate),
          endAt(eDate)
        )
      : // 최신순으로 정렬
        query(chatRoomsRef, orderByChild("message/time"));

    // lastTime 이후 최근 11개 메세지 받기
    const pagedRef =
      clickCnt !== cnt
        ? query(orderedChatRoomsRef, limitToLast(11), endBefore(lastTime))
        : query(orderedChatRoomsRef, limitToLast(11));

    try {
      onValue(pagedRef, (snapshot) => {
        let msgs: IMessageData[] = [];

        snapshot.forEach((child) => {
          const childValue = child.val();

          if (childValue.message !== undefined) {
            msgs.push({
              sendBy: childValue?.message.sender,
              receivedBy: childValue?.message.receiver,
              msg: childValue?.message.msg,
              time: childValue?.message.time,
              isRead: childValue?.message.isRead,
              key: child?.key,
            });
          }
        });

        setMoreMessageData(msgs);

        if (isFirst && msgs?.length === 0) {
          toast.error("메세지가 없습니다.");
        }

        setMessageData(
          isFirst ? msgs?.reverse() : messageData.concat(msgs?.reverse())
        );

        setMore(false);

        setCnt(clickCnt);
      });
    } catch (error) {
      console.log(error);
    }
  };

  // 메세지 10개씩 가져오기
  useEffect(() => {
    console.log("🚨useeffect");

    if (chatId) {
      getMessage(0, true);
    }
  }, [chatId, dateData?.btn]);

  useEffect(() => {}, [more]);

  useEffect(() => {
    if (messageData?.length > 0) {
      setLastTime(messageData[messageData?.length - 1]?.time);
    }
  }, [messageData]);

  return (
    <ChatSection id="recent-chat-section">
      <ChatSectionTitle>최근 대화 조회</ChatSectionTitle>

      <RecentChatHeader
        setDateData={setDateData}
        dropDownValue={dropDownValue}
        searchValue={searchValue}
      />

      <Blank blankHeight={12} />

      <LineBox>
        <Table tableHeadData={tableHead}>
          <>
            {(moreMessageData?.length > 10 ? true : false) &&
              messageData?.length > 10 && (
                <More
                  src={require("../../../../../assets/table/more_navigation_28@2x.png")}
                  onClick={() => {
                    setMore(true);

                    setDataSliceValue((prev) => prev + 10);
                    getMessage(cnt + 1, false);
                  }}
                />
              )}
          </>

          <>
            {messageData
              ?.slice(
                0,
                moreMessageData?.length < 11
                  ? messageData?.length
                  : dataSliceValue
              ) // dataSliceValue: more 버튼 클릭할 때 마다 10개씩 늘어남
              ?.reverse()
              ?.map((d: IMessageData, index: number) => {
                return (
                  <RecentChatMessage
                    d={d}
                    chatId={chatId}
                    index={index}
                    messageData={messageData}
                  />
                );
              })}
          </>
        </Table>
      </LineBox>
    </ChatSection>
  );
}

export const CalendarLine = styled.div`
  width: 12px;
  height: 1px;
  background-color: #858c97;
`;

export const HelpIcon = styled.span`
  font-size: 24px;
  color: #858c97;
`;

export const More = styled.img`
  cursor: pointer;
  position: absolute;
  left: 47%;
  margin-top: -23px;
  width: 46px;
  height: 46px;
`;
